import { ProductVatConfigData } from '@/types/product-vat-config.types';

export const normalizeProductVatConfigDate = (value?: string | null) => {
  if (!value) return null;
  return value.includes('T') ? value.split('T')[0] : value;
};

export const isProductVatConfigActive = (
  config: Pick<ProductVatConfigData, 'active_to'>,
  today = new Date()
) => {
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  const todayStr = `${yyyy}-${mm}-${dd}`;

  const activeToDate = normalizeProductVatConfigDate(config.active_to);
  return !activeToDate || activeToDate > todayStr;
};
